import styled from "styled-components";
export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
`;
export const SurveyOptions = styled.div`
  width: 320px;
  text-align: center;
  font-size: 12px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 4px 20px;
  margin-bottom: 10px;
  &.selected {
    border: 2px solid rgba(0, 0, 0, 0.7);
  }
`;
export const SelectedSurveyOptions = styled.div`
  width: 320px;
  text-align: center;
  font-size: 12px;
  border: 2px solid rgba(0, 0, 0, 0.7);
  border-radius: 12px;
  padding: 4px 20px;
  margin-bottom: 10px;
`;
